import { makeType, actionCreator } from "../../Utils/generateActionCreator";
import { API } from "aws-amplify";

const actionType = makeType("POLICY");

export const ADDITIONAL_INFO_1 = actionType("ADDITIONAL_INFO_1");
export const ADDITIONAL_INFO_2 = actionType("ADDITIONAL_INFO_2");
export const ADDITIONAL_INFO_2_INSURED = actionType(
  "ADDITIONAL_INFO_2_INSURED"
);
export const ADDITIONAL_INFO_2_CONTRACTOR = actionType(
  "ADDITIONAL_INFO_2_CONTRACTOR"
);
export const ADD_QUIZ_DPS = actionType("ADD_QUIZ_DPS");
export const ADD_INFEXOFI = actionType("ADD_INFEXOFI");
export const COUNTRY_OA = actionType("COUNTRY_OA");

export const additionalInfo1 = actionCreator(
  ADDITIONAL_INFO_1,
  "additionalInfo1"
);
export const additionalInfo2 = actionCreator(
  ADDITIONAL_INFO_2,
  "additionalInfo2"
);
export const additionalInfo2Insured = actionCreator(
  ADDITIONAL_INFO_2_INSURED,
  "additionalInfo2Insured"
);
export const additionalInfo2Contractor = actionCreator(
  ADDITIONAL_INFO_2_CONTRACTOR,
  "additionalInfo2Contractor"
);
export const addQuizDPS = actionCreator(ADD_QUIZ_DPS, "quizDPS");
export const addInfexofi = actionCreator(ADD_INFEXOFI, "infexofi");
export const countryOA = actionCreator(COUNTRY_OA, "countryOA");

export const getAdditionalInfo1 = async (dispatch, code, isAbove10k) => {
  let response = null;
  if (isAbove10k) {
    response = await API.post("api-rentas", "/quiz", {
      body: { section: "INFFONDOS" },
    });
  } else {
    if (code === "RG") {
      response = await API.post("api-rentas", "/quiz", {
        body: { section: "INFCTABANC" },
      });
    } else {
      response = await API.post("api-rentas", "/quiz", {
        body: { section: "INFCOMP", order: "1" },
      });
    }
  }
  if (response.status) dispatch(additionalInfo1(response.data));
};

export const getAdditionalInfo2 = async (dispatch, code) => {
  const response = await API.post("api-rentas", "/quiz", {
    body: { section: "INFCOMP", order: "2" },
  });

  if (response.status) dispatch(additionalInfo2(response.data));
};

export const getAdditionalInfo2Insured = async (dispatch) => {
  const response = await API.post("api-rentas", "/quiz", {
    body: { section: "INFCOMP-V2" },
  });

  if (response.status) dispatch(additionalInfo2Insured(response.data));
};

export const getAdditionalInfo2Contractor = async (dispatch) => {
  const response = await API.post("api-rentas", "/quiz", {
    body: { section: "INFCOMP-V2-CONT" },
  });

  if (response.status) dispatch(additionalInfo2Contractor(response.data));
};

export const getQuizDPS = async (dispatch) => {
  const response = await API.post("api-rentas", "/quiz", {
    body: { section: "DPS#AS" },
  });
  if (response.status) dispatch(addQuizDPS(response.data));
};

export const getInfexofi = async (dispatch) => {
  const response = await API.post("api-rentas", "/quiz", {
    body: { section: "INFEXOFI" },
  });
  if (response.status && response.data && response.data.length > 0) {
    dispatch(addInfexofi(response.data[0].metadata));
  }
};

export const getCountryOA = async (dispatch) => {
  const response = await API.post("api-rentas", "/quiz", {
    body: { section: "COUNTRY#OA" },
  });
  if (response.status) dispatch(countryOA(response.data));
};
